<template>
    <div class="autocomplete">
        <input
                :value="value"
                @input.prevent="onChange"
                @keydown.enter.prevent="onEnter"
                @keyup.down="onArrowDown"
                @keyup.up="onArrowUp"
                :class="['form-control',classes]"
                type="text"
                v-bind="$attrs"
        />
        <ul class="autocomplete-results" ref="autoCompleteResults" v-show="isOpen">
            <li class="loading" v-if="isLoading">
                Loading results...
            </li>
            <li
                    :class="{ 'is-active': i === arrowCounter }"
                    :key="i"
                    @click="setResult(result)"
                    class="autocomplete-result"
                    v-else
                    v-for="(result, i) in results">
                {{ result.name }}
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        inheritAttrs: false,
        props: {
            /** The list of items in {id,name} format to either search or returned as search results. This should be reactive and updated in the parent component on search */
            items: {
                type: Array,
                required: false,
            },
            /** Indicates if the search is async, so show a loader until the item set changes */
            isAsync: {
                type: Boolean,
                required: false,
                default: false
            },
            value: {
                type: String,
                required: false
            },
            classes:{
                type:Object,
                required:false
            }
        },

        data() {
            return {
                isOpen: false,
                results: [],
                isLoading: false,
                arrowCounter: 0,
            };
        },

        methods: {
            onChange(event) {
                // Is the data given by an outside ajax request?
                if (this.isAsync) {
                    this.isLoading = true;
                } else {
                    this.filterResults();
                }
                this.$emit("input", event.target.value);
                this.isOpen = true;
            },

            /** Only used in non-async searches: filters the list of existing items against the search result */
            filterResults() {
                this.results = this.items.filter(item => {
                    return item.name.toLowerCase().indexOf(this.value.toLowerCase()) > -1;
                });
            },

            /** Sets the search result, closes the window, and emits the selected event to notify the parent when a result has been selected */
            setResult(result) {
                this.isOpen = false;
                this.arrowCounter = -1;

                // Notify the parent of the newly selected value (we want the entire object, not just the name in the search)
                this.$emit("selected", result);
            },

            /** Enables scrolling down the result list with the arrow keys */
            onArrowDown(evt) {
                if (this.arrowCounter < this.results.length - 1) {
                    this.arrowCounter = this.arrowCounter + 1;
                    this.$refs.autoCompleteResults.children[
                        this.arrowCounter
                        ].scrollIntoView(false);
                }
            },

            /** Enables scrolling up the result list with the arrow keys */
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                    this.$refs.autoCompleteResults.children[
                        this.arrowCounter
                        ].scrollIntoView();
                }
            },

            /** Sets the current active li item as the value for this component */
            onEnter() {
                if (this.arrowCounter >= 0) {
                    this.setResult(this.results[this.arrowCounter]);
                }
            },

            /** Closes the search list if the user clicks outside the control */
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    this.isOpen = false;
                    this.arrowCounter = -1;
                }
            }
        },
        watch: {
            /** When the list of results gets updated, update the result list which displays more refined search results */
            items: function (val, oldValue) {
                this.results = val;
                this.isLoading = false;
                this.isOpen = true;
            }
        },
        mounted() {
            document.addEventListener("click", this.handleClickOutside);
        },
        destroyed() {
            document.removeEventListener("click", this.handleClickOutside);
        }
    };
</script>


<style scoped>
    .autocomplete {
        position: relative;
    }

    .autocomplete-results {
        padding-left: 5px;
        margin: 0;
        border: 1px solid #eeeeee;
        height: 120px;
        overflow: auto;
        width: 100%;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 3px 8px;
        cursor: pointer;
    }

    .autocomplete-result.is-active,
    .autocomplete-result:hover {
        background-color: rgb(108, 117, 125);
        color: white;
    }
</style>
